module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("Magic Over Boys (Shadowlight Academy, #2)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c005"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c006"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOCIETY OF SUPERNATURAL SLEUTHS")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scarlet’s Three")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shadowlight Academy | PLAYLIST")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FADE")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wicked Woods")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stoker Sisters")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BITTER FROST")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Want to Know More about Shadowlight Academy, Author Insight, Author Appearance, Contests and Giveaways? | Get New Releases and News from Kailin Gow at her website kailingow")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0